import { createSlice } from '@reduxjs/toolkit';
import { getLocalStorage, setLocalStorage } from '../Helper/helperFunctions';

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState: {
    isCollapsed: true,
    currentRoute: getLocalStorage("currentRoute") || "home",
    // Set by the location editor while it has unsaved changes, so the sidebar
    // can warn before navigating away instead of silently discarding them.
    hasUnsavedEditorChanges: false,
    // Debug window in the location editor (FPS/memory/selection readout) —
    // toggled from the sidebar's admin settings, persisted across reloads.
    debugMode: getLocalStorage("debugMode") === 'true',
  },
  reducers: {
    toggleSidebar: (state) => {
      state.isCollapsed = !state.isCollapsed;
    },
    setSidebarCollapsed: (state, action) => {
      state.isCollapsed = action.payload;
    },
    setCurrentRoute: (state, action) => {
      state.currentRoute = action.payload;
      setLocalStorage("currentRoute", state.currentRoute);
    },
    setHasUnsavedEditorChanges: (state, action) => {
      state.hasUnsavedEditorChanges = action.payload;
    },
    setDebugMode: (state, action) => {
      state.debugMode = action.payload;
      setLocalStorage("debugMode", action.payload ? 'true' : 'false');
    },
  },
});

export const { toggleSidebar, setSidebarCollapsed, setCurrentRoute, setHasUnsavedEditorChanges, setDebugMode } = sidebarSlice.actions;
export default sidebarSlice.reducer;
